export const priceFormat = (price: string | number | null, currency?: string) => {
  if (price === null || price === undefined) return null;

  if (!currency)
    return new Intl.NumberFormat('en-EN', {
      maximumFractionDigits: 4,
      minimumFractionDigits: 2,
    }).format(+price);

  return new Intl.NumberFormat('en-EN', {
    currency,
    maximumFractionDigits: 4,
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(+price);
};

export const currencySymbol = (currency: string) => {
  return (priceFormat(0, currency) ?? '').toString().replace('0.00', '').trim();
};
